const rulesCheckListInit = [
  { text: 'Mínimo 8 caracteres', state: 'undone' },
  { text: 'Sin espacios en blanco', state: 'undone' },
  { text: 'Al menos una letra mayúscula', state: 'undone' },
  { text: 'Al menos una letra minúscula', state: 'undone' },
  { text: 'Al menos un caracter especial', state: 'undone' },
  { text: 'Al menos un número y máximo 2 consecutivos', state: 'undone' },
];

export default {
  data() {
    return {
      rulesCheckList: rulesCheckListInit,
    };
  },
  methods: {
    validatePasswordRules(password) {
      this.length(password)
        ? (this.rulesCheckList[0].state = 'done')
        : (this.rulesCheckList[0].state = 'undone');
      this.noWhiteSpaces(password)
        ? (this.rulesCheckList[1].state = 'done')
        : (this.rulesCheckList[1].state = 'undone');
      this.upperCase(password)
        ? (this.rulesCheckList[2].state = 'done')
        : (this.rulesCheckList[2].state = 'undone');
      this.lowerCase(password)
        ? (this.rulesCheckList[3].state = 'done')
        : (this.rulesCheckList[3].state = 'undone');
      this.specialCharacter(password)
        ? (this.rulesCheckList[4].state = 'done')
        : (this.rulesCheckList[4].state = 'undone');
      this.number(password)
        ? (this.rulesCheckList[5].state = 'done')
        : (this.rulesCheckList[5].state = 'undone');
    },
    passwordRequired(password) {
      return !!password || 'Este campo es requerido';
    },
    length(password) {
      return password.length >= 8;
    },
    noWhiteSpaces(password) {
      return password !== '' && !/\s/.test(password);
    },
    upperCase(password) {
      const passwordRules = /^(?=.*[A-Z])/;
      return passwordRules.test(password);
    },
    lowerCase(password) {
      const passwordRules = /^(?=.*[a-z])/;
      return passwordRules.test(password);
    },
    specialCharacter(password) {
      const passwordRules = /^(?=.*[@.#$!%*?&^])[A-Za-z\d@.#$!%*?&]/;
      return passwordRules.test(password);
    },
    number(password) {
      const passwordRules = /^(?=.*\d)/;
      return (
        passwordRules.test(password) && this.isValidNumberSequence(password)
      );
    },
    passwordMatch(password, newPassword) {
      return password === newPassword || 'Las constraseñas no coinciden';
    },
    isValidNumberSequence(password) {
      // 000, 111, 999
      const repeatedDigits = /(\d)\1\1/;

      // 123, 234, 321, 210
      const sequentialDigits =
        /(012|123|234|345|456|567|678|789|987|876|765|654|543|432|321|210)/;

      return !repeatedDigits.test(password) && !sequentialDigits.test(password);
    },
    resetRulesCheckList() {
      this.validatePasswordRules('');
    },
  },
};
